/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKeys = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13.217 6.249a5.001 5.001 0 0 1 3.075 7.65l5.02 5.02-3.526 3.524-1.414-1.414 2.11-2.11-1.414-1.414-1.403 1.403-1.414-1.414 1.403-1.404-.78-.78a5.002 5.002 0 0 1-6.28-.645l1.415-1.414a3 3 0 1 0 2.774-5.05z" />
        <path d="M7 2a5 5 0 0 1 .984 9.902V19H3v-2h2.985v-2H4v-2h1.985v-1.103A5.001 5.001 0 0 1 7 2zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
      </g>
    </g>
  </Icon>
);
export { SvgKeys as Keys };
